'use client';

import Script from 'next/script';
import { Env } from '@/consts/Env';

export const Cookiebot = () => {
  const cookiebotId = Env.NEXT_PUBLIC_COOKIEBOT_ID;

  return (
    <Script
      id="cookiebot"
      strategy="afterInteractive"
      src="https://consent.cookiebot.com/uc.js"
      data-cbid={cookiebotId}
      // If something went wrong with cookiebot , see on this comment first
      // data-blockingmode="auto"
      type="text/javascript"
    />
  );
};
